import styles from '../styles/Layout.module.sass';
import { FC, useEffect, useState } from 'react';
import { Container, Content, Drawer, Footer, Header, Sidebar } from 'rsuite';
import { useHistory } from 'react-router';
import HeaderContent from './HeaderContent';
import NavMenu from './NavMenu';
import NavMenu2 from './NavMenu2';
import FooterContent from './FooterContent';
import routes from 'utils/routes';

const Layout: FC = ({ children }) => {
  const [activeKey, setActiveKey] = useState<string>(window.location.pathname);
  const [open, setOpen] = useState<boolean>(true);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const history = useHistory();

  let viewTitle = routes.filter(r => r.path === activeKey)[0]?.label;

  if (viewTitle == undefined)
  {
    if (activeKey.includes('opciones'))
    {
      viewTitle = 'Recuperar Contraseña';
      setActiveKey('/recuperar');
    }
    else if(activeKey.includes('modificacionrecuperacion'))
    {
      viewTitle = 'Datos de Recuperación';
      setActiveKey('/tiposrecuperacion');
    }
    else if(activeKey.includes('cambiocontrasena'))
    {
      viewTitle = 'Modificar Contraseña';
      setActiveKey('/comprobar');
    }
    else if (activeKey.includes('/'))
    {
      viewTitle = 'Modificar Contraseña';
      setActiveKey('/comprobar');
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      if (window.innerWidth < 800) {
        setOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      setActiveKey(location.pathname);
    })
  }, [history]);

  const renderSidebar = () => {
    return screenWidth > 800 ? (
      <Sidebar>
        <NavMenu
          routes={routes}
          activeKey={activeKey}
          onSelect={setActiveKey}
        />
      </Sidebar>
    ) : (
      <Drawer
        
        open={open}
        onClose={()=>setOpen(false)}
        placement="top"
        size="sm"
      >
        <Drawer.Body onClick={()=>setOpen(false)}>
          <NavMenu2
            routes={routes}
            activeKey={activeKey}
            onSelect={setActiveKey}
          />
        </Drawer.Body>
      </Drawer>
    )
  }

  return (screenWidth > 800 ? (
    <Container>
      { renderSidebar() }
      <Container>
        <Header>
          <HeaderContent section={viewTitle} open={open} setOpen={setOpen}/>          
        </Header>
        <Content className={styles.content}>         
          { children }
        </Content>
        <Footer>
          <FooterContent />
        </Footer>
      </Container>
    </Container>
  ) 
  : 
  (
    <Container>      
      { renderSidebar() }
      <Container>
        <Header>
          <HeaderContent section={viewTitle} open={open} setOpen={setOpen}/>
        </Header>
        <Content className={styles.content} style={{textAlign: 'left'}} >
          { children }
        </Content>
        <Footer>
          <FooterContent />
        </Footer>
      </Container>
    </Container>
  )
  );
}

export default Layout;